const CONFIGURATION_RESET = 'CONFIGURATION/RESET';

export default function configurationResetAction () {
  return {
    type: CONFIGURATION_RESET,
    payload: {}
  };
}

export { CONFIGURATION_RESET };